import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({ standalone: false,
    selector: 'irb-move-securities-warnings-dialog',
    templateUrl: './move-securities-warnings-dialog.component.html',
    styleUrls: ['./move-securities-warnings-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class MoveSecuritiesWarningsDialogComponent implements OnInit {
    warningsData: {
        currentGroupSecurity: any,
        responseData: any[],
        hasCashSecurity: boolean,
        groupSecurities: any[],
        smaSecurities: any[],
        externalSecurities: any[],
        processArray: any[]
    };
    continueFunction: (warningsData: any) => {};

    constructor(public dialogRef: MatDialogRef<MoveSecuritiesWarningsDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public mdd: any) {

    }

    ngOnInit(): void {
        this.warningsData = this.mdd.securitiesWarningsData;
        this.continueFunction = this.mdd.continueFunction;
    }

    close() {
        this.dialogRef.close();
    }

    onContinue() {
        this.continueFunction(this.warningsData);
        this.dialogRef.close();
    }
    getCommaSeparatedList(securities: any[]) {
        let returnValue = "";
        if(securities && securities.length > 0) {
            let securitySymbols = securities.map(function(item) {
                return item.securitySymbol;
            });
            returnValue = securitySymbols.join(",");
        }
        return returnValue;
    }

}
